  // Form status enum
  export enum FormStatus {
    INITIATED = 'initiated',
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed'
  }